import React, { useEffect, useState } from 'react'
import { TransactionHeading } from './TransactionHeader'
import { Wrapper, ShowMore } from './style'
import { InvestmentTitleText } from 'src/components/Global/Text/TitleText'
import { useTypedSelector } from 'src/redux/root-reducer'
import { useDispatch } from 'react-redux'
import Select from 'react-select'
import { SkeletonTransaction } from 'src/components/Global/Skeletons/TransactionSkeletons'
import {
  getPageTransactions,
  transactionAction,
  SearchTransactions,
  filterTransactionsService,
  filterTransactionsStatus,
  filterTransactionsType,
} from 'src/redux/actions/transaction'
import {
  searchTransaction,
  inactiveArrowRight,
  inactiveArrowLeft,
  activeArrowRight,
  activeArrowLeft,
} from 'src/assets'
import { VscArrowSmallLeft } from 'react-icons/vsc'
import { QuicksaveInput } from 'src/components/Global/Input/Input'

const MoreTransaction = () => {
  const dispatch = useDispatch()
  useEffect(() => {
    dispatch(transactionAction())
  }, [])
  const [clicked, setClicked] = useState(false)
  const transaction = useTypedSelector(
    (state) => state.transactionsReducer.transactionsResult.transactions
  )

  const transactionLoading = useTypedSelector(
    (state) => state.transactionsReducer.loading
  )
  const [searchData, setSearchData] = useState({
    search: '',
  })
  const style = {
    menuPortal: (base: any) => ({
      ...base,
      zIndex: 9999,
      backgroundColor: '${({ theme }) => theme.colors.white}',
      border: ' 1px solid rgba(228, 228, 228, 0.6)',
      height: '50px',
      borderRadius: '5px',
    }),
  }
  const options = [
    { value: 'save', label: 'Save' },
    { value: 'withdraw', label: 'Withdraw' },
    { value: 'interest', label: 'Interest' },
    { value: 'processing', label: 'Processing' },
    { value: 'failed', label: 'Failed' },
    { value: 'successful', label: 'Successful' },
    { value: 'cancelled', label: 'Cancelled' },
    { value: 'plan', label: 'Plan' },
    { value: 'investment', label: 'Investment' },
    { value: 'safe', label: 'Safe' },
  ]
  const handleOption = (options: any) => {
    console.log(options.value)
    if (
      options.value === 'save' ||
      options.value === 'withdraw' ||
      options.value === 'interest'
    ) {
      dispatch(filterTransactionsType(options.value))
    }
    if (
      options.value === 'processing' ||
      options.value === 'failed' ||
      options.value === 'successful' ||
      options.value === 'cancelled'
    ) {
      dispatch(filterTransactionsStatus(options.value))
    }
    if (
      options.value === 'plan' ||
      options.value === 'investment' ||
      options.value === 'safe'
    ) {
      dispatch(filterTransactionsService(options.value))
    }
  }
  const { search } = searchData
  // const transactionInfo = transaction.transactions

  const prevPage = () => {
    if (transaction.pagination.prev) {
      let url_string = transaction.pagination.prev
      var url = new URL(url_string)
      var pageNumber = url.searchParams.get('page')
      console.log(pageNumber)
      dispatch(getPageTransactions(pageNumber))
    }
  }
  const nextPage = () => {
    if (transaction.pagination.next) {
      let url_string = transaction.pagination.next
      var url = new URL(url_string)
      var pageNumber = url.searchParams.get('page')
      console.log(pageNumber)
      dispatch(getPageTransactions(pageNumber))
    }
  }
  const handleChange = (e: any) => {
    const { name, value } = e.target
    const newData: any = { ...searchData }
    newData[name] = value
    setSearchData(newData)
    setClicked(true)
  }
  const onSearchMember = () => {
    dispatch(SearchTransactions(searchData.search))
  }
  return (
    <Wrapper>
      <InvestmentTitleText>Transactions</InvestmentTitleText>
      <div className="filter">
        <div className="search-bar">
          <QuicksaveInput
            type="text"
            placeholder="Transaction Description"
            name="search"
            value={search}
            onChange={handleChange}
            className="inputWidth"
          />
          {clicked && (
            <div className="search" onClick={(e: any) => onSearchMember()}>
              <img src={searchTransaction} alt="" />
            </div>
          )}
        </div>
        <Select
          placeholder="Filter"
          options={options}
          onChange={handleOption}
          styles={style}
          className="filter_select"
          menuPortalTarget={document.body}
        />
      </div>
      <div className="margin">
        {transactionLoading &&
          [1, 2, 3, 4, 5, 6, 7, 8, 9].map((n) => (
            <SkeletonTransaction key={n} theme="light" />
          ))}
        {!transactionLoading && <TransactionHeading />}
        <ShowMore>
          <div className="showNum">
            <p className="show-page"></p>
            Showing{' '}
            <span className="page">
              Page {transaction?.pagination.current_page} of{'  '}
              {transaction?.pagination.total_pages}
            </span>
          </div>
          <div className="arrows">
            {!transaction?.pagination.prev && (
              <img src={inactiveArrowLeft} onClick={prevPage} alt="" />
            )}
            {transaction?.pagination.prev && (
              <img src={activeArrowLeft} onClick={prevPage} alt="" />
            )}
            {!transaction?.pagination.next && (
              <img src={inactiveArrowRight} alt="" onClick={nextPage} />
            )}
            {transaction?.pagination.next && (
              <img src={activeArrowRight} alt="" onClick={nextPage} />
            )}
          </div>
        </ShowMore>
      </div>
    </Wrapper>
  )
}

export { MoreTransaction }
